import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { DeviceService } from 'src/app/services/devices/device.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/services/modal/modal.service';
import { LoadingPopupComponent } from 'src/app/components/ui/loading-popup/loading-popup.component';
import { ModernErrorModalComponent } from 'src/app/components/ui/modern-error-modal/modern-error-modal.component';


export interface Rate {
    id:      number;
    type:    string;
    periods: Period[];
}

export interface Period {
    power:    number;
    price:    number;
    schedule: Schedule[];
}

export interface Schedule {
    weekday:   number;
    init_time: string;
    end_time:  string;
}

const CURRENCIES = [
  { code: 'EUR', symbol: '€' },
  { code: 'USD', symbol: '$' },
  { code: 'GBP', symbol: '£' },
  { code: 'COP', symbol: '$' },
] as const;

type CurrencyCode = (typeof CURRENCIES)[number]['code'];

@Component({
    selector: 'app-electricity-rate',
    templateUrl: './electricity-rate.component.html',
    styleUrl: './electricity-rate.component.scss',
    standalone: false
})

export class ElectricityRateComponent implements OnInit {

  type = 'fixed'  // fixed, periods, custom
  periods = 2 // 2 or 3
  currencies = CURRENCIES;
  coin: CurrencyCode = 'EUR';



  tFija : Rate['periods'][0] = {price: 0, power: 0, schedule: [{weekday: 127, init_time: '00:00', end_time: '23:59'}]}
  tPeriods : Rate['periods'] = [
    {
      price: 0,
      power: 0,
      schedule: [{weekday: 127, init_time: '00:00', end_time: '23:59'}]
    },
    {
      price: 0,
      power: 0,
      schedule: [{weekday: 31, init_time: '00:00', end_time: '23:59'}]
    }
  ]
  tcustom: Rate['periods'] = [
    {
      price: 0,
      power: 0,
      schedule: [{weekday: 31, init_time: '22:00:00', end_time: '08:00:59'}]
    }
  ]

    // Variables para el modal
  showModal = false;
  editingSlot: any = {
    start: '08:00',
    end: '22:00',
    days: [],
    isNew: true,
    periodIndex: 0,
    slotIndex: 0,
    isCustom: false
  };

  device: string = '';
  modalLoad: NgbModalRef;
  successMessage: boolean = false;
  error : string = '';

  orginalData: any = null;

  // Propiedades auxiliares para los precios
  get puntaPrice(): number {
    return this.tPeriods[0]?.price || 0;
  }

  set puntaPrice(value: number) {
    if (this.tPeriods[0]) {
      this.tPeriods[0].price = value;
    }
  }

  get llanoPrice(): number {
    return this.tPeriods[1]?.price || 0;
  }

  set llanoPrice(value: number) {
    if (this.tPeriods[1]) {
      this.tPeriods[1].price = value;
    }
  }

  get vallePrice(): number {
    const valleIndex = this.tPeriods.length - 1;
    return this.tPeriods[valleIndex]?.price || 0;
  }

  set vallePrice(value: number) {
    const valleIndex = this.tPeriods.length - 1;
    if (this.tPeriods[valleIndex]) {
      this.tPeriods[valleIndex].price = value;
    }
  }

  get symbolCoin(): string {
    return this.currencies.find((c) => c.code === this.coin)?.symbol ?? '€';
  }

  constructor(
    public translate: TranslateService,
    private _deviceService: DeviceService,
    private _aRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private _modal: ModalService,
    private _router: Router
  ) { }

  ngOnInit(): void {
    this._aRoute.parent?.parent?.params
    .subscribe((params: Params) => this.device = params['serial']);

    this._deviceService.getElectricityRate(this.device).subscribe((data) => {
      console.log('tarifa obtenida', data.cfg);
      if (!data.cfg) {
        this.orginalData = null;
        this.type = 'fixed';
        this.coin = 'EUR';
        this.tFija = {price: 0, power: 0, schedule: [{weekday: 127, init_time: '00:00', end_time: '23:59'}]};
        return;
      }
      this.coin = data.cfg?.coin || 'EUR';
      this.type = data.cfg?.type || 'fixed';
      if (data.cfg) {
        this.orginalData = JSON.parse(JSON.stringify(data.cfg));
      }
      if (this.type === 'fixed') {
        this.tFija = data.cfg?.periods?.[0] || {price: 0, power: 0, schedule: [{weekday: 127, init_time: '00:00', end_time: '23:59'}]};
      } else if (data.cfg?.type === '2periods' || data.cfg?.type === '3periods') {
        this.type = 'periods';
        this.periods = data.cfg?.periods?.length || 2;
        this.tPeriods = data.cfg?.periods || [{price: 0, power: 0, schedule: [{weekday: 127, init_time: '00:00', end_time: '23:59'}]}, {price: 0, power: 0, schedule: [{weekday: 31, init_time: '00:00', end_time: '23:59'}]}] ;

        // Forzar detección de cambios
        this.cdr.detectChanges();
      } else if (this.type === 'custom') {
        this.tcustom = data.cfg.periods;
      }
    });
  }


  setTwoPeriods(): void {
    this.periods = 2;
    // Si hay 3 períodos, eliminar el período Llano (posición 1)
    if (this.tPeriods.length === 3) {
      this.tPeriods.splice(1, 1);
    }
  }

  setThreePeriods(): void {
    this.periods = 3;
    // Si solo hay 2 períodos, insertar el período Llano en la posición 1
    if (this.tPeriods.length === 2) {
      const llanoPeriod = {
        price: 0,
        power: 0,
        schedule: [{weekday: 31, init_time: '10:00:00', end_time: '14:00:59'}] // Días laborables por defecto
      };
      this.tPeriods.splice(1, 0, llanoPeriod);
    }
  }


  // Obtiene el índice del período Valle (último elemento del array)
  getValleIndex(): number {
    return this.tPeriods.length - 1;
  }


  // Obtiene texto descriptivo de los días desde un weekday binario
  getScheduleDaysFromWeekday(weekday: number): string {
    const days = this.binaryToDaysArray(weekday);
    return this.getScheduleDaysText(days);
  }

  // Formatea la hora para mostrar (elimina segundos)
  formatTimeForDisplay(time: string): string {
    return time.substring(0, 5); // "08:00:00" -> "08:00"
  }

  addPeriod() {
    const newPeriod = {
      price: 0,
      power: 0,
      schedule: [{weekday: 31, init_time: '08:00:00', end_time: '22:00:59'}]
    };
    this.tcustom.push(newPeriod);
  }

  removePeriod(index: number) {
    if (this.tcustom.length > 1) {
      this.tcustom.splice(index, 1);
    }
  }

  removeTimeSlot(periodIndex: number, slotIndex: number): void {
    if (this.tPeriods[periodIndex].schedule.length > 1) {
      this.tPeriods[periodIndex].schedule.splice(slotIndex, 1);
    }
  }
  removeCustomTimeSlot(periodIndex: number, slotIndex: number): void {
    if (this.tcustom[periodIndex].schedule.length > 1) {
      this.tcustom[periodIndex].schedule.splice(slotIndex, 1);
    }
  }


  // Abrir modal para añadir nuevo horario
  addNewTimeSlot(periodIndex: number): void {
    this.editingSlot = {
      start: '08:00',
      end: '22:00',
      days: ['L', 'M', 'X', 'J', 'V'],
      isNew: true,
      periodIndex: periodIndex,
      slotIndex: 0,
      isCustom: false
    };
    this.showModal = true;
  }

  // Abrir modal para editar horario existente
  editTimeSlot(periodIndex: number, slotIndex: number): void {
    const slot = this.tPeriods[periodIndex].schedule[slotIndex];
    const days = this.binaryToDaysArray(slot.weekday);
    this.editingSlot = {
      start: slot.init_time.substring(0, 5), // Convertir "08:00:00" a "08:00"
      end: slot.end_time.substring(0, 5),    // Convertir "22:00:59" a "22:00"
      days: [...days],
      isNew: false,
      periodIndex: periodIndex,
      slotIndex: slotIndex,
      isCustom: false
    };
    this.showModal = true;
  }

  // Abrir modal para añadir nuevo horario personalizado
  addNewCustomTimeSlot(periodIndex: number): void {
    this.editingSlot = {
      start: '08:00',
      end: '22:00',
      days: ['L', 'M', 'X', 'J', 'V'],
      isNew: true,
      periodIndex: periodIndex,
      slotIndex: 0,
      isCustom: true
    };
    this.showModal = true;
  }

  // Abrir modal para editar horario personalizado existente
  editCustomTimeSlot(periodIndex: number, slotIndex: number): void {
    const slot = this.tcustom[periodIndex].schedule[slotIndex];
    const days = this.binaryToDaysArray(slot.weekday);
    this.editingSlot = {
      start: slot.init_time.substring(0, 5), // Convertir "08:00:00" a "08:00"
      end: slot.end_time.substring(0, 5),    // Convertir "22:00:59" a "22:00"
      days: [...days],
      isNew: false,
      periodIndex: periodIndex,
      slotIndex: slotIndex,
      isCustom: true
    };
    this.showModal = true;
  }

  closeModal(): void {
    this.showModal = false;
  }

  // Añadir horarios
  saveTimeSlot(): void {
    const newScheduleItem = {
      weekday: this.daysArrayToBinary(this.editingSlot.days),
      init_time: this.editingSlot.start + ':00',
      end_time: this.editingSlot.end + ':59'
    };

    if (this.editingSlot.isCustom) {
      if (this.editingSlot.isNew) {
        this.tcustom[this.editingSlot.periodIndex].schedule.push(newScheduleItem);
      } else {
        this.tcustom[this.editingSlot.periodIndex].schedule[this.editingSlot.slotIndex] = newScheduleItem;
      }
    } else {
      if (this.editingSlot.isNew) {
        this.tPeriods[this.editingSlot.periodIndex].schedule.push(newScheduleItem);
      } else {
        this.tPeriods[this.editingSlot.periodIndex].schedule[this.editingSlot.slotIndex] = newScheduleItem;
      }
    }

    this.closeModal();
  }

  // Verificar si un día está seleccionado en el modal
  isModalDaySelected(day: string): boolean {
    return this.editingSlot.days.includes(day);
  }

  // Toggle día en el modal
  toggleModalDay(day: string): void {
    const index = this.editingSlot.days.indexOf(day);
    if (index > -1) {
      this.editingSlot.days.splice(index, 1);
    } else {
      this.editingSlot.days.push(day);
    }
  }

  save() {
    // Validar de periodos
    if (this.type === 'periods' || this.type === 'custom') {
      const periodsToValidate = this.type === 'custom' ? this.tcustom : this.tPeriods.slice(0, this.periods);
      const validation = this.validateFullCoverage(periodsToValidate);

      if (!validation.valid) {
        const errorModal = this._modal.open(ModernErrorModalComponent);
        errorModal.componentInstance.title = this.translate.instant('rateValidationError');
        errorModal.componentInstance.message = this.translate.instant('scheduleConfigurationError');
        errorModal.componentInstance.details = validation.message;
        errorModal.componentInstance.type = this.translate.instant('error');
        return;
      } else if (validation.message.includes('⚠️')) {
        // Mostrar modal de advertencia con opción de continuar o cancelar
        const warningModal = this._modal.open(ModernErrorModalComponent);
        warningModal.componentInstance.title = this.translate.instant('configurationWarning');
        warningModal.componentInstance.message = this.translate.instant('configurationWarningMessage');
        warningModal.componentInstance.details = validation.message;
        warningModal.componentInstance.type = this.translate.instant('warning');
        warningModal.componentInstance.showTwoButtons = true;

        // Manejar la respuesta del usuario
        warningModal.result.then((result) => {
          if (result === 'confirm') {
            // Usuario eligió continuar y guardar
            this.comfirmSave();
          }
          // Si result es undefined o cualquier otra cosa, no hacer nada (cancelar)
        }).catch(() => {
          // Usuario cerró el modal o canceló - no guardar
          console.log('Usuario canceló el guardado tras la advertencia');
        });
        return;
      }
    }

    this.comfirmSave();
  }

  private comfirmSave() {

    this.modalLoad = this._modal.open(LoadingPopupComponent);

    let payload: { type: string; periods: Rate['periods'], coin: CurrencyCode };

    switch (this.type) {
      case 'custom':
        payload = { type: this.type, periods: this.tcustom, coin: this.coin };
        break;

      case 'periods':
        const periodsPeriods = this.tPeriods.slice(0, this.periods);
        payload = { type: this.periods + 'periods', periods: periodsPeriods, coin: this.coin };
        break;

      case 'fixed':
        payload = { type: this.type, periods: [this.tFija], coin: this.coin };
        break;

      default:
        console.error('Tipo de tarifa no válido:', this.type);
        if (this.modalLoad) {
          this.modalLoad.close();
        }
        return;
    }

    this._deviceService.setElectricityRate(this.device, payload).subscribe({
      next: (data) => {
        this.orginalData = JSON.parse(JSON.stringify({
          type: payload.type,
          periods: payload.periods,
          coin: payload.coin,
        }));
        if (this.modalLoad) {
          setTimeout(() => {
            this.modalLoad.close();
            this.successMessage = true;
            setTimeout(() => {
              this.successMessage = false;
            }, 2000);
          }, 1000);

        }
      },
      error: (error) => {
        console.error('Error al guardar la tarifa:', error);
        if (this.modalLoad) {
          this.modalLoad.close();
        }
        const errorModal = this._modal.open(ModernErrorModalComponent);
        errorModal.componentInstance.title = 'Error al Guardar';
        errorModal.componentInstance.message = 'No se pudo guardar la configuración de la tarifa.';
        errorModal.componentInstance.details = 'Por favor, verifica tu conexión a internet e inténtalo de nuevo. Si el problema persiste, contacta al soporte técnico.';
        errorModal.componentInstance.type = 'error';
      }
    });
  }

  // Obtener la clase CSS del período para el modal
  getPeriodModalClass(): string {
    if (this.editingSlot.isCustom) {
      return 'modal-header-custom';
    }

    // Para períodos predefinidos, determinar el tipo según el índice y número de períodos
    const periodIndex = this.editingSlot.periodIndex;

    // Lógica corregida para 2 y 3 períodos
    if (this.periods === 2) {
      if (periodIndex === 0) {
        return 'modal-header-punta';
      } else if (periodIndex === 1) {
        return 'modal-header-valle'; // En modo 2 períodos, índice 1 es Valle
      }
    } else if (this.periods === 3) {
      if (periodIndex === 0) {
        return 'modal-header-punta';
      } else if (periodIndex === 1) {
        return 'modal-header-llano'; // En modo 3 períodos, índice 1 es Llano
      } else if (periodIndex === 2) {
        return 'modal-header-valle'; // En modo 3 períodos, índice 2 es Valle
      }
    }

    return 'modal-header-default';
  }


// ========== Mapa binario de días  ==========
  daysArrayToBinary(days: string[]): number {
    const dayMap: {[key: string]: number} = {
      'L': 1,   // Lunes
      'M': 2,   // Martes
      'X': 4,   // Miércoles
      'J': 8,   // Jueves
      'V': 16,  // Viernes
      'S': 32,  // Sábado
      'D': 64   // Domingo
    };

    return days.reduce((binary, day) => binary + (dayMap[day] || 0), 0);
  }

  binaryToDaysArray(weekday: number): string[] {
    const days: string[] = [];
    const dayMap: {[key: number]: string} = {
      1: 'L',   // Lunes
      2: 'M',   // Martes
      4: 'X',   // Miércoles
      8: 'J',   // Jueves
      16: 'V',  // Viernes
      32: 'S',  // Sábado
      64: 'D'   // Domingo
    };

    for (const [bit, day] of Object.entries(dayMap)) {
      if (weekday & parseInt(bit)) {
        days.push(day);
      }
    }
    return days;
  }

  // Atajos rápidos
  setQuickPreset(preset: string): void {
    switch (preset) {
      case 'weekdays':
        this.editingSlot.days = ['L', 'M', 'X', 'J', 'V'];
        break;
      case 'weekend':
        this.editingSlot.days = ['S', 'D'];
        break;
      case 'all':
        this.editingSlot.days = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
        break;
    }
  }

    // Obtener texto descriptivo de los días
  getScheduleDaysText(days: string[]): string {
    if (!days || days.length === 0) return 'Sin días';

    if (days.length === 7) return  this.translate.instant('allDays');

    const weekdays = ['L', 'M', 'X', 'J', 'V'];
    const weekend = ['S', 'D'];

    const hasAllWeekdays = weekdays.every(day => days.includes(day));
    const hasAllWeekend = weekend.every(day => days.includes(day));
    if (hasAllWeekdays && hasAllWeekend) return this.translate.instant('allDays');
    if (hasAllWeekdays && days.length === 5) return this.translate.instant('workdays');
    if (hasAllWeekend && days.length === 2)  return this.translate.instant('weekend');

    return days.join(', ');
  }





  // Verifica si hay solapamientos dentro del mismo período
  checkInternalOverlaps(periods: Rate['periods']): { hasOverlap: boolean; message: string } {
    const overlaps: string[] = [];

    periods.forEach((period, periodIndex) => {
      if (period.schedule.length > 1) {
        // Verificar solapamientos entre schedules del mismo período
        for (let i = 0; i < period.schedule.length; i++) {
          for (let j = i + 1; j < period.schedule.length; j++) {
            const schedule1 = period.schedule[i];
            const schedule2 = period.schedule[j];

            // Verificar si hay días comunes
            if (schedule1.weekday & schedule2.weekday) {
              const overlap = this.checkTimeOverlap(schedule1, schedule2);
              if (overlap) {
                const periodName = ` ${this.translate.instant('period')} ${periodIndex + 1}`;
                const dayNames = this.getWeekdayNames(schedule1.weekday & schedule2.weekday);
                overlaps.push(`${periodName} ${this.translate.instant('hasOverlappingSchedules')} ${dayNames} (${overlap})`);
              }
            }
          }
        }
      }
    });

    if (overlaps.length > 0) {
      return {
        hasOverlap: true,
        message: `${this.translate.instant('foundInternalOverlaps')} \n${overlaps.join('\n')}\n\n ${this.translate.instant('considerVerifyingOverlappingSchedules')}.`
      };
    }

    return { hasOverlap: false, message: this.translate.instant('noInternalOverlaps') };
  }


  //  Verifica si hay solapamientos entre periodos
  checkForOverlaps(periods: Rate['periods']): { hasOverlap: boolean; message: string } {
    const overlaps: string[] = [];

    for (let i = 0; i < periods.length; i++) {
      for (let j = i + 1; j < periods.length; j++) {
        const period1 = periods[i];
        const period2 = periods[j];

        // Verificar solapamientos entre todos los schedules de ambos periodos
        for (const schedule1 of period1.schedule) {
          for (const schedule2 of period2.schedule) {
            // Verificar si hay días comunes
            if (schedule1.weekday & schedule2.weekday) {
              // Hay días comunes, verificar solapamiento horario
              const overlap = this.checkTimeOverlap(schedule1, schedule2);
              if (overlap) {
                const period1Name = ` ${this.translate.instant('period')} ${i + 1}`;
                const period2Name = ` ${this.translate.instant('period')} ${j + 1}`;
                const dayNames = this.getWeekdayNames(schedule1.weekday & schedule2.weekday);
                overlaps.push(`${period1Name} ${this.translate.instant('and')} ${period2Name} ${this.translate.instant('overlapOn')} ${dayNames} (${overlap})`);
              }
            }
          }
        }
      }
    }

    if (overlaps.length > 0) {
      return {
        hasOverlap: true,
        message: `${this.translate.instant('foundOverlaps')} \n${overlaps.join('\n')}`
      };
    }

    return { hasOverlap: false, message: this.translate.instant('noOverlaps') };
  }


  //  Verifica si dos schedules se solapan en tiempo
  private checkTimeOverlap(schedule1: any, schedule2: any): string | null {
    const start1 = this.timeToMinutes(schedule1.init_time);
    const end1 = this.timeToMinutes(schedule1.end_time);
    const start2 = this.timeToMinutes(schedule2.init_time);
    const end2 = this.timeToMinutes(schedule2.end_time);

    // Manejar horarios que cruzan medianoche
    const crosses1 = start1 > end1;
    const crosses2 = start2 > end2;

    if (!crosses1 && !crosses2) {
      // Ninguno cruza medianoche
      if (start1 < end2 && start2 < end1) {
        return `${schedule1.init_time}-${schedule1.end_time} ⟷ ${schedule2.init_time}-${schedule2.end_time}`;
      }
    } else if (crosses1 && !crosses2) {
      // Solo el primer horario cruza medianoche
      if (start1 < end2 || start2 < end1 + 24 * 60) {
        return `${schedule1.init_time}-${schedule1.end_time} ⟷ ${schedule2.init_time}-${schedule2.end_time}`;
      }
    } else if (!crosses1 && crosses2) {
      // Solo el segundo horario cruza medianoche
      if (start2 < end1 || start1 < end2 + 24 * 60) {
        return `${schedule1.init_time}-${schedule1.end_time} ⟷ ${schedule2.init_time}-${schedule2.end_time}`;
      }
    } else {
      // Ambos cruzan medianoche - siempre se solapan
      return `${schedule1.init_time}-${schedule1.end_time} ⟷ ${schedule2.init_time}-${schedule2.end_time}`;
    }

    return null;
  }

  /**
   * Convierte tiempo HH:mm a minutos desde medianoche
   */
  private timeToMinutes(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }

  /**
   * Obtiene los nombres de los días de la semana a partir de un weekday binario
   */
  private getWeekdayNames(weekday: number): string {
    const dayNames = { 1: 'L', 2: 'M', 4: 'X', 8: 'J', 16: 'V', 32: 'S', 64: 'D' };
    const dayBits = [1, 2, 4, 8, 16, 32, 64];
    const names: string[] = [];

    dayBits.forEach(bit => {
      if (weekday & bit) {
        names.push(dayNames[bit as keyof typeof dayNames]);
      }
    });

    return names.join(', ');
  }

  /**
   * Valida que los períodos cubran completamente las 24 horas del día y toda la semana
   */
  validateFullCoverage(periods: Rate['periods']): { valid: boolean; message: string } {
    // Primero verificar si hay solapamientos entre períodos diferentes
    const overlapCheck = this.checkForOverlaps(periods);
    if (overlapCheck.hasOverlap) {
      return { valid: false, message: overlapCheck.message };
    }

    // Verificar solapamientos internos (dentro del mismo período) - mostrar como advertencia
    const internalOverlapCheck = this.checkInternalOverlaps(periods);

    // Continuar con la validación de cobertura completa
    const coverage: { [day: number]: boolean[] } = {};

    // Inicializar cobertura para cada día (usando bits de weekday)
    const dayBits = [1, 2, 4, 8, 16, 32, 64]; // L, M, X, J, V, S, D

    dayBits.forEach(bit => {
      coverage[bit] = new Array(24).fill(false);
    });

    // Marcar todas las horas cubiertas por cada período
    periods.forEach(period => {
      period.schedule.forEach(schedule => {
        const startHour = parseInt(schedule.init_time.split(':')[0]);
        const endHour = parseInt(schedule.end_time.split(':')[0]);
        const endMinute = parseInt(schedule.end_time.split(':')[1]);

        // Si termina en :59, incluir esa hora completa
        const actualEndHour = endMinute >= 59 ? endHour : endHour - 1;

        // Obtener días de la semana de este schedule
        const daysForSchedule = this.getWeekdayBitsFromBinary(schedule.weekday);

        daysForSchedule.forEach(dayBit => {
          // Marcar horas cubiertas
          if (startHour <= actualEndHour) {
            // Horario normal (no cruza medianoche)
            for (let hour = startHour; hour <= actualEndHour; hour++) {
              coverage[dayBit][hour] = true;
            }
          } else {
            // Horario que cruza medianoche
            for (let hour = startHour; hour < 24; hour++) {
              coverage[dayBit][hour] = true;
            }
            for (let hour = 0; hour <= actualEndHour; hour++) {
              coverage[dayBit][hour] = true;
            }
          }
        });
      });
    });

    // Verificar cobertura completa
    const uncoveredDays: string[] = [];
    const dayNames = { 1: this.translate.instant('monday'), 2: this.translate.instant('tuesday'), 4: this.translate.instant('wednesday'), 8: this.translate.instant('thursday'), 16: this.translate.instant('friday'), 32: this.translate.instant('saturday'), 64: this.translate.instant('sunday') };

    dayBits.forEach(bit => {
      const dayHours = coverage[bit];
      const uncoveredHours: number[] = [];

      dayHours.forEach((covered, hour) => {
        if (!covered) {
          uncoveredHours.push(hour);
        }
      });

      if (uncoveredHours.length > 0) {
        uncoveredDays.push(`${dayNames[bit as keyof typeof dayNames]}: horas ${uncoveredHours.join(', ')}`);
      }
    });

    if (uncoveredDays.length > 0) {
      return {
        valid: false,
        message: ` ${this.translate.instant('incompleteCoverage')} \n${uncoveredDays.join('\n')}`
      };
    }

    // Si hay solapamientos internos, incluir como advertencia en el mensaje de éxito
    if (internalOverlapCheck.hasOverlap) {
      return {
        valid: true,
        message: `${this.translate.instant('fullCoverageVerified')}.\n\n⚠️  ${this.translate.instant('warning').toUpperCase()}:\n${internalOverlapCheck.message}`
      };
    }

    return { valid: true, message:  this.translate.instant('fullCoverageVerified') };
  }

  /**
   * Convierte un número binario de weekday a array de bits individuales
   */
  private getWeekdayBitsFromBinary(weekday: number): number[] {
    const bits: number[] = [];
    const dayBits = [1, 2, 4, 8, 16, 32, 64]; // L, M, X, J, V, S, D

    dayBits.forEach(bit => {
      if (weekday & bit) {
        bits.push(bit);
      }
    });

    return bits;
  }


  cancel(): void {
    if (!this.orginalData) {
      return;
    }

    const apiType = this.orginalData.type;
    const savedCoin = this.orginalData.coin;
    this.coin = this.currencies.some((c) => c.code === savedCoin) ? savedCoin : 'EUR';

    if (apiType === 'fixed') {
      this.type = 'fixed';
      this.tFija = JSON.parse(JSON.stringify(this.orginalData.periods[0]));
    } else if (apiType === '2periods' || apiType === '3periods') {
      this.type = 'periods';
      this.periods = this.orginalData.periods.length;
      this.tPeriods = JSON.parse(JSON.stringify(this.orginalData.periods));
    } else if (apiType === 'custom') {
      this.type = 'custom';
      this.tcustom = JSON.parse(JSON.stringify(this.orginalData.periods));
    }

    this.cdr.detectChanges();
  }

}
